/*
 * Copyright (c) 2024 GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */

import { MenuItem } from "@mui/material";
import ArgosFlexbox from "../../../../../components/Containers/ArgosFlexbox";
import ArgosSelect from "../../../../../components/Form/Select/ArgosSelect";
import { MRT_Cell, MRT_ColumnDef, MaterialReactTable } from "material-react-table";
import { ObjectPropertiesInput, ObjectPropertyRow, objectPropertiesInput } from "../../constants";
import { useEffect, useState } from "react";
import { toast } from "react-hot-toast";
import { useHasWriteAccess } from "../../../../../../redux/ducks/AccessControl/accessControlHelpers";
import { ArgosTable } from "../../../../../components/Table/ArgosTable";
import {ArgosTableSimple} from "../../../../../components/Table/ArgosTableSimple";


interface IObjectPropertiesProps {
  baselineData: any
  isDialogOpen: any
  gmid: string
  configIndex: any
  setIsPublicConfig: any
  newDataList: any
  setSelectedObject: any,
  setSelectedPointsFrames: any,
  temperatureArray: number[],
  handleTempChange: any
}
const ObjectProperties = (props: IObjectPropertiesProps) => {
  const [tableData, setTableData] = useState<any>([]);
  const dataList = props?.newDataList
  const [selectedName, setSelectedName] = useState<string>(props?.baselineData?.selectedObject);
  const [selectedPointsFrame, setSelectedPointsFrame] = useState<string>(props?.baselineData?.selectedPointsFrames)
  useEffect(() => {
    populateTable();
    setSelectedPointsFrame(props?.baselineData?.selectedPointsFrames)
    setSelectedName(props?.baselineData?.selectedObject)
  }, [props])

  const populateTable = () => {
    let _tableData: ObjectPropertyRow[] = []
    let data = props?.baselineData;
    objectPropertiesInput.forEach((element: ObjectPropertiesInput) => {
      let _tableDataObject: ObjectPropertyRow = {
        objectPropertyName: element.label,
        objectPropertyValue: data?.[element.key],
        objectPropertyKey: element.key,
      }
      _tableData.push(_tableDataObject)
    })
    setTableData(_tableData)
  }

  const handleObjectNameChange = (e: any) => {
    setSelectedName(e)
    props?.setSelectedObject(e)
  }

  const objectPropertiesRowColumns : MRT_ColumnDef<ObjectPropertyRow>[] = [
    {
      header: "Name",
      accessorKey: "objectPropertyName",
      enableEditing: false,
    },
    {
      header: "Value",
      accessorKey: "objectPropertyValue",
      enableEditing: false,
      minSize: 700,
      Cell: ({ cell }) => {
        let _objectPropertyKey: string = cell.row.original.objectPropertyKey
        let isPointFrames: boolean = _objectPropertyKey === "pointsFrames"

        let dropDownValue:string =  selectedName;

        let pointsFramesMenuItems: any = [dataList?.pointsFrames]
        let objectNameMenuItems: any = [dataList?.objectName]
        let menuItems

        let cellValue: any = cell.getValue()
        switch(_objectPropertyKey) {
          case "pointsFrames":
            menuItems = pointsFramesMenuItems
            dropDownValue = selectedPointsFrame
            cellValue = selectedPointsFrame
            break;
          case "objectName":
            menuItems = objectNameMenuItems
            break;
          case "objectProperties":
            if (props?.baselineData.objectCategory == "Baseline") {
                dropDownValue = props?.baselineData?.objectVariant;
                menuItems = ["Front Profile"]
              } else if (props?.baselineData.objectCategory != "Custom") {
                dropDownValue = props?.baselineData?.objectVariant;
                menuItems = ["Front Profile", "Side Profile", "Rear Profile"]
              } else {
                dropDownValue = "";
                menuItems = []
              }
              break;
            case "objectCategory":
              dropDownValue = props?.baselineData?.objectCategory;
              menuItems = ["Baseline"]
              break;
            case "temperature":
              dropDownValue = props?.baselineData?.temperature
              menuItems = props?.temperatureArray
              break;
          default:
            menuItems = []
        }

        if (!(_objectPropertyKey === "objectVersion" || isPointFrames)) {
          return (
          <ArgosSelect
            value={dropDownValue}
            onChange={(e: any) => {
              if (cell.row.original.objectPropertyKey == "objectName") {
                handleObjectNameChange(e.target.value)
              } else if (cell.row.original.objectPropertyKey === 'temperature') {
                props?.handleTempChange(e.target.value)
              }
            }}
          >
            {menuItems.map((item: any) => <MenuItem value={String(item)}>{item} </MenuItem>)}
          </ArgosSelect>)
        }
        else {

          const value: any = (typeof cellValue === 'number' || cellValue?.length > 0) ? cellValue : 'N/A';
          return <div>{value}</div>
        }
      }
    },
    {
      header: "Unit",
      accessorKey: "unit",
      enableEditing: false,
    },
  ]
  return (
    <div style={{padding: "5px"}}>
      <ArgosTableSimple
        columns={objectPropertiesRowColumns}
        data={tableData}
        editDisplayMode="cell"
        enableEditing
        enableBottomToolbar={false}
        muiTableProps={{
          sx: {
            tableLayout: 'fixed',
          },
        }}
        initialState={{density: 'compact'}}
      />
    </div>)
}
export default ObjectProperties;